module.exports = __webpack_public_path__ + "media/images/nl/ICON-HERHAAL-1-9bfbfc17ea357117887561abb09dac7b.png";